<template>
  <div>
    <div class="Kanit">
      <div class="text-center mb-4">
        <h3 style="color: #0c4d9d" class="mb-1">กรอกที่อยู่ใบกำกับภาษี</h3>
      </div>
      <ValidationObserver ref="observer" tag="form">
        <form>
          <ValidationProvider
            :name="'เลขประจำตัวผู้เสียภาษี'"
            :rules="'required'"
            key="เลขประจำตัวผู้เสียภาษี"
            v-slot="{ errors, valid }"
          >
            <v-text-field
              large
              class="mb-0"
              outlined
              type="number"
              v-model="input.taxid"
              label="Tax ID"
              placeholder="เลขประจำตัวผู้เสียภาษี"
              :error-messages="errors"
              :valid="valid"
            ></v-text-field>
          </ValidationProvider>
          <ValidationProvider
            :name="'ชื่อจริง'"
            :rules="'required'"
            key="firstname"
            v-slot="{ errors, valid }"
          >
            <v-text-field
              large
              class="mb-0"
              outlined
              @input="input.first_name = removeHiddenSpace($event)"
              v-model="input.first_name"
              label="Firstname"
              placeholder="ชื่อจริง"
              :error-messages="errors"
              :valid="valid"
            ></v-text-field>
          </ValidationProvider>
          <ValidationProvider
            :name="'นามสกุล'"
            :rules="'required'"
            key="lastname"
            v-slot="{ errors, valid }"
          >
            <v-text-field
              outlined
              name="lastname"
              class="mb-0"
              @input="input.last_name = removeHiddenSpace($event)"
              v-model="input.last_name"
              label="Lastname"
              placeholder="นามสกุล"
              :error-messages="errors"
              :valid="valid"
            ></v-text-field>
          </ValidationProvider>

          <ValidationProvider
            :name="'เบอร์โทรศัพท์'"
            :rules="'required'"
            key="phoneno"
            v-slot="{ errors, valid }"
          >
            <v-text-field
              rows="4"
              auto-grow
              outlined
              type="number"
              name="phoneno"
              v-model="input.phone_number"
              label="Phone number"
              placeholder="เบอร์โทรศัพท์"
              :error-messages="errors"
              :valid="valid"
            ></v-text-field>
          </ValidationProvider>

          <ValidationProvider
            :name="'อีเมล์'"
            :rules="'required|email'"
            key="email"
            v-slot="{ errors, valid }"
          >
            <v-text-field
              outlined
              name="email"
              class="mb-0"
              v-model.trim="input.email"
              v-removeHiddenSpace
              label="Email"
              placeholder="อีเมล์"
              :error-messages="errors"
              :valid="valid"
            ></v-text-field>
          </ValidationProvider>

          <ValidationProvider
            :name="'รหัสไปรษณีย์'"
            :rules="'required'"
            key="zipcode"
            v-slot="{ errors }"
          >
            <thai-address-input
              v-model="input.zip_code"
              type="zipcode"
              @select="onSelectAddress"
              :placeholder="`รหัสไปรษณีย์`"
              :label="`Zipcode`"
              :error-messages="errors"
              :hide-details="errors.length == 0"
            ></thai-address-input>
          </ValidationProvider>
          <div style="clear: both"></div>
          <ValidationProvider
            :name="'จังหวัด'"
            :rules="'required'"
            key="province"
            v-slot="{ errors }"
          >
            <thai-address-input
              v-model="input.province"
              type="province"
              :label="`Province`"
              placeholder="จังหวัด"
              @select="onSelectAddress"
              :error-messages="errors"
              :hide-details="errors.length == 0"
            ></thai-address-input>
          </ValidationProvider>
          <div style="clear: both"></div>

          <ValidationProvider
            :name="'อำเภอ/เขต'"
            :rules="'required'"
            key="amphoe"
            v-slot="{ errors }"
          >
            <thai-address-input
              v-model="input.sub_district"
              type="amphoe"
              :label="`District`"
              placeholder="อำเภอ/เขต"
              @select="onSelectAddress"
              :error-messages="errors"
              :hide-details="errors.length == 0"
            ></thai-address-input>
          </ValidationProvider>
          <div style="clear: both"></div>
          <ValidationProvider
            :name="'ตำบล/แขวง'"
            :rules="'required'"
            key="district"
            v-slot="{ errors }"
          >
            <thai-address-input
              v-model="input.district"
              type="district"
              :label="'Sub-district'"
              placeholder="ตำบล/แขวง"
              @select="onSelectAddress"
              :error-messages="errors"
              :hide-details="errors.length == 0"
            ></thai-address-input>
          </ValidationProvider>
          <div style="clear: both"></div>

          <ValidationProvider
            :name="'ที่อยู่'"
            :rules="'required'"
            key="addressno"
            v-slot="{ errors }"
          >
            <v-textarea
              @input="input.address1 = removeHiddenSpace($event)"
              v-model="input.address1"
              outlined
              rows="3"
              label="Address"
              class="mb-6"
              placeholder="ที่อยู่ บ้านเลขที่ หมู่บ้าน ถนน"
              :error-messages="errors"
              :hide-details="errors.length == 0"
            ></v-textarea>
          </ValidationProvider>
        </form>
        <div>
          <v-btn
            :loading="$store.state.taxloading"
            @click="saveData"
            dark
            block
            color="#0c4d9d"
          >
            ยืนยัน
          </v-btn>
          <v-btn @click="$emit('close')" text block color="#0c4d9d">
            ยกเลิก
          </v-btn>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import ThaiAddressInput from "@/components/ThaiAddressInput";
export default {
  props: {
    defaultaddress: {
      default: null,
    },
  },
  components: {
    ThaiAddressInput,
  },
  mounted() {
    var address = this.$store.state.address.find(
      (el) => el.id == this.$store.state.activeAddress
    );
    Object.assign(this.input, address);
  },
  data() {
    return {
      input: {
        taxid: "",
        first_name: "",
        last_name: "",
        phone_number: "",
        email: "",
        zip_code: "",
        province: "",
        sub_district: "",
        district: "",
        address1: "",
      },
    };
  },
  methods: {
    async saveData() {
      if (await this.$refs.observer.validate()) {
        this.$emit("saveTax", this.input);
      }
    },
    onSelectAddress(address) {
      this.input.sub_district = address.amphoe;
      this.input.district = address.district;
      this.input.province = address.province;
      this.input.zip_code = address.zipcode;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>